import React from 'react';
import { Copy, Square, Stack } from '@grubhubprod/gh-cookbook-react';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { GroceriesHero } from 'src/components/enterprise/features/Groceries/components/GroceriesHero/GroceriesHero';
import { GroceriesHowItWorks } from 'src/components/enterprise/features/Groceries/components/GroceriesHowItWorks/GroceriesHowItWorks';
import { GroceriesFaqs } from 'src/components/enterprise/features/Groceries/components/GroceriesFaqs/GroceriesFaqs';
import { getGroceriesContent } from 'src/components/enterprise/features/Groceries/constants/groceriesContent';
import { getGroceriesOrderNowUrl } from 'src/components/enterprise/features/Groceries/utils/getGroceriesOrderNowUrl';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { getBrandDisplayName } from 'src/utilities/getBrandDisplayName';

export function GroceriesLandingPage(): JSX.Element {
  const { corpData } = useAuth();
  const brand = corpData?.brand;
  const brandDisplayName = getBrandDisplayName(brand);
  const groceriesContent = getGroceriesContent(brand);
  const orderNowUrl = getGroceriesOrderNowUrl(brand);

  return (
    <Square inset="lg">
      <Stack y="lg">
        <PageHeader>
          <PageTitle title="Groceries" />
          <Stack y="sm">
            <Copy variant="body" color="secondaryText">
              {groceriesContent.page.subtitle}
            </Copy>
          </Stack>
        </PageHeader>
        <Stack y="md">
          <GroceriesHero
            groceriesContent={groceriesContent}
            brandDisplayName={brandDisplayName}
            orderNowUrl={orderNowUrl}
          />
        </Stack>
        <Stack y="md">
          <GroceriesHowItWorks groceriesContent={groceriesContent} />
        </Stack>
        <GroceriesFaqs groceriesContent={groceriesContent} />
      </Stack>
    </Square>
  );
}
